"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortOrder = void 0;
var SortOrder;
(function (SortOrder) {
    SortOrder["DESC"] = "desc";
    SortOrder["ASC"] = "asc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
//# sourceMappingURL=app.js.map